import styled from 'styled-components';

import { TextEllipsisMixin } from '../../../../theme/layout';
import { COLORS } from '../../../../theme/color';

export const Container = styled.div`
  background-color: ${COLORS.blueReference};
  box-sizing: border-box;
  height: 20px;
  border-radius: 3px;
  min-width: 20px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 7px;
  flex-shrink: 0;
`;

export const Name = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.grayMainText};

  ${TextEllipsisMixin}
`;
